// src/components/ProtectedRoute.jsx
import { useLocation } from "react-router-dom";
import useCockpitGuard from "../hooks/useCockpitGuard";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const guard = useCockpitGuard();

  // Allow QR analytics without guard
  if (location.pathname.includes("qr-analytics")) {
    return children;
  }

  // ⭐ FIX: Do NOT block while loading
  if (guard.loading) {
    return <div>Loading...</div>;
  }

  // ⭐ FIX: Only block AFTER loading finishes AND profile is null
  if (!guard.profile) {
    return <div>No access</div>;
  }

  // ⭐ FIX: Profile exists → allow access
  return children;
}
